import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { endpoints } from '../../../constants/endpoints';
import { IGrupoRentabilidade } from '../interfaces/grupo-rentabilidade.interface';
import { IGruposRentabilidadeResponse } from '../interfaces/grupos-rentabilidade-response.interface';

@Injectable({
  providedIn: 'root',
})
export class GruposRentabilidadeApi {
  private apiUrl = `${environment.pathApi}/${endpoints.environment.gruposRentabilidade}`;

  constructor(
    private http: HttpClient
  ) {}

  fetchList(): Observable<IGruposRentabilidadeResponse[]> {
    return this.http.get<IGruposRentabilidadeResponse[]>(this.apiUrl);
  }

  fetchById(id: number): Observable<IGrupoRentabilidade> {
    return this.http.get<IGrupoRentabilidade>(`${this.apiUrl}/${id}`);
  }

  update(grupo: Partial<IGrupoRentabilidade>): Observable<IGrupoRentabilidade> {
    return this.http.put<IGrupoRentabilidade>(`${this.apiUrl}/${grupo.id}`, grupo);
  }
}
